<template>
	<div>
		<RadioGroup
			v-model="yesNo"
			:options="yesNoOptions"
			@change="emitChangeEvent"
		/>
	</div>
</template>
<script>
import {isDefined} from "@/helper/Value";
import {mapState} from "vuex";
import RadioGroup from "@/vue/common/form/RadioGroup";
import * as Overtime from "@/helper/application/Overtime"

export default {

	components: {
		RadioGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			yesNo: this.value?.yesNo,
			yesNoOptions: Object.freeze([
				{value: Overtime.YES, text: Overtime.getLabel(Overtime.YES)},
				{value: Overtime.NO, text: Overtime.getLabel(Overtime.NO)},
			])
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		yesNoValid ()
		{
			return isDefined(this.yesNo);
		},
		dataValid ()
		{
			return this.yesNoValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				yesNo: this.yesNo
			});
		},
	}
}
</script>
